import React from "react";
import PageShell from "../../components/layout/PageShell";
import useScrollReveal from "../../hooks/useScrollReveal";

export default function Chiffres() {
  useScrollReveal();

  return (
    <PageShell
      title="Chiffres clés"
      subtitle="Les indicateurs de performance de l'École de la Magistrature"
    >
      {/* Hero Stats */}
      <section className="ema-reveal" style={{
        background: 'linear-gradient(135deg, #0B2C5F 0%, #1e3a6e 100%)',
        borderRadius: '24px',
        padding: '48px 40px',
        marginBottom: '48px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '200px',
          height: '200px',
          borderRadius: '50%',
          background: 'rgba(212,175,55,0.1)',
        }} />
        <div style={{
          position: 'absolute',
          bottom: '-30px',
          left: '20%',
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.03)',
        }} />
        <p style={{ color: '#D4AF37', fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '8px' }}>
          Depuis 2016
        </p>
        <h2 style={{ color: '#fff', fontSize: '22px', fontWeight: 800, marginBottom: '28px' }}>
          L'EMA en un coup d'œil
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px' }}>
          <StatHero value="363" label="Apprenants accompagnés" />
          <StatHero value="8" label="Promotions formées" />
          <StatHero value="30+" label="Formateurs experts" />
          <StatHero value="95%" label="Taux de réussite" />
        </div>
      </section>

      {/* Magistrats - Section visuelle */}
      <section className="ema-reveal" style={{ marginBottom: '48px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          <div style={{ width: '4px', height: '32px', background: '#D4AF37', borderRadius: '4px' }} />
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#0B2C5F' }}>Magistrats en fonction</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
          <StatCard value="275+" label="Magistrats diplômés" icon={<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>} color="#0B2C5F" />
          <StatCard value="150+" label="Juges de paix" icon={<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v18"/><path d="M3 7h18"/><path d="M6 7l-3 5h6"/><path d="M18 7l3 5h-6"/></svg>} color="#1e40af" />
          <StatCard value="80+" label="Tribunaux de 1ère instance" icon={<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18"/><path d="M5 21V7l8-4 8 4v14"/><path d="M9 21v-4h6v4"/></svg>} color="#0B2C5F" />
          <StatCard value="45+" label="Cours d'appel" icon={<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>} color="#1e40af" />
        </div>
      </section>

      {/* Formation - Barres de progression */}
      <section className="ema-reveal" style={{ marginBottom: '48px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          <div style={{ width: '4px', height: '32px', background: '#0B2C5F', borderRadius: '4px' }} />
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#0B2C5F' }}>Programmes de formation</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', padding: '28px', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
            <ProgressBar label="Heures de formation" value={2500} max={3000} suffix="h" />
            <ProgressBar label="Modules pédagogiques" value={45} max={50} suffix="" />
            <ProgressBar label="Sessions annuelles" value={12} max={15} suffix="" />
            <ProgressBar label="Partenariats actifs" value={4} max={6} suffix="" />
          </div>
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', padding: '28px', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
            <ProgressBar label="Taux de réussite" value={95} max={100} suffix="%" color="#10b981" />
            <ProgressBar label="Taux d'insertion" value={90} max={100} suffix="%" color="#10b981" />
            <ProgressBar label="Satisfaction diplômés" value={85} max={100} suffix="%" color="#D4AF37" />
            <ProgressBar label="Couverture départements" value={10} max={10} suffix="/10" color="#0B2C5F" />
          </div>
        </div>
      </section>

      {/* Infrastructure */}
      <section className="ema-reveal" style={{
        background: 'linear-gradient(135deg, rgba(11,44,95,0.03) 0%, rgba(212,175,55,0.04) 100%)',
        borderRadius: '20px',
        padding: '40px',
        marginBottom: '48px',
        border: '1px solid rgba(11,44,95,0.08)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '28px' }}>
          <div style={{ width: '4px', height: '32px', background: '#D4AF37', borderRadius: '4px' }} />
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#0B2C5F' }}>Infrastructure & ressources</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px' }}>
          <InfraCard value="6" label="Salles de classe" icon={<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>} />
          <InfraCard value="1" label="Bibliothèque juridique" icon={<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>} />
          <InfraCard value="2000+" label="Ouvrages disponibles" icon={<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>} />
          <InfraCard value="15" label="Postes informatiques" icon={<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 8h4"/><path d="M7 12h8"/></svg>} />
        </div>
      </section>

      {/* Couverture géographique */}
      <section className="ema-reveal" style={{ marginBottom: '48px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          <div style={{ width: '4px', height: '32px', background: '#0B2C5F', borderRadius: '4px' }} />
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#0B2C5F' }}>Couverture nationale</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
          <div style={{
            background: 'linear-gradient(135deg, #0B2C5F 0%, #1e3a6e 100%)',
            borderRadius: '16px',
            padding: '32px',
            color: '#fff'
          }}>
            <div style={{ fontSize: '32px', fontWeight: 900, lineHeight: 1, marginBottom: '8px' }}>10</div>
            <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '14px', opacity: 0.9 }}>Départements couverts</div>
            <p style={{ fontSize: '13px', opacity: 0.75, lineHeight: 1.6 }}>
              Nos diplômés exercent dans tous les départements géographiques d'Haïti, assurant une couverture nationale de la justice.
            </p>
          </div>
          <div style={{
            background: 'linear-gradient(135deg, #D4AF37 0%, #f4d03f 100%)',
            borderRadius: '16px',
            padding: '32px',
            color: '#071b3b'
          }}>
            <div style={{ fontSize: '32px', fontWeight: 900, lineHeight: 1, marginBottom: '8px' }}>200+</div>
            <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '14px' }}>Juridictions desservies</div>
            <p style={{ fontSize: '13px', opacity: 0.8, lineHeight: 1.6 }}>
              Tribunaux de paix, tribunaux de première instance et cours d'appel comptent des magistrats formés à l'EMA.
            </p>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="ema-reveal">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '28px' }}>
          <div style={{ width: '4px', height: '32px', background: '#D4AF37', borderRadius: '4px' }} />
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#0B2C5F' }}>Évolution depuis 2016</h2>
        </div>
        <div style={{ position: 'relative', paddingLeft: '32px' }}>
          <div style={{ position: 'absolute', left: '11px', top: '8px', bottom: '8px', width: '2px', background: 'linear-gradient(to bottom, #0B2C5F, #D4AF37)' }} />
          <TimelineItem year="2016" title="Première promotion" text="40 magistrats formés, lancement de l'institution." />
          <TimelineItem year="2018" title="Extension" text="80 nouveaux magistrats formés, élargissement des programmes." />
          <TimelineItem year="2020" title="Formation continue" text="Lancement des programmes de formation continue." />
          <TimelineItem year="2022" title="Renforcement" text="120 nouveaux diplômés, développement des partenariats." />
          <TimelineItem year="2024" title="Modernisation" text="Introduction des technologies éducatives et campus numérique." />
          <TimelineItem year="2026" title="Expansion" text="Plus de 350 magistrats formés depuis la création." last />
        </div>
      </section>
    </PageShell>
  );
}

function StatHero({ value, label }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '32px', fontWeight: 900, color: '#fff', lineHeight: 1, marginBottom: '8px' }}>{value}</div>
      <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)', fontWeight: 500 }}>{label}</div>
    </div>
  );
}

function StatCard({ value, label, icon, color }) {
  return (
    <div style={{
      background: '#fff',
      border: '1px solid #e5e7eb',
      borderRadius: '16px',
      padding: '24px 20px',
      textAlign: 'center',
      boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
      transition: 'all 0.3s ease',
      cursor: 'default'
    }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 12px 32px rgba(11,44,95,0.1)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.04)';
      }}
    >
      <div style={{ marginBottom: '12px', color: color, display: 'flex', justifyContent: 'center' }}>{icon}</div>
      <div style={{ fontSize: '22px', fontWeight: 900, color: color, lineHeight: 1, marginBottom: '8px' }}>{value}</div>
      <div style={{ fontSize: '12px', fontWeight: 600, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
    </div>
  );
}

function ProgressBar({ label, value, max, suffix, color = '#0B2C5F' }) {
  const percent = Math.round((value / max) * 100);
  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
        <span style={{ fontSize: '14px', fontWeight: 600, color: '#374151' }}>{label}</span>
        <span style={{ fontSize: '14px', fontWeight: 700, color: color }}>{value}{suffix}</span>
      </div>
      <div style={{ height: '8px', background: '#f3f4f6', borderRadius: '100px', overflow: 'hidden' }}>
        <div style={{
          height: '100%',
          width: `${percent}%`,
          background: `linear-gradient(90deg, ${color}, ${color}cc)`,
          borderRadius: '100px',
          transition: 'width 1s ease'
        }} />
      </div>
    </div>
  );
}

function InfraCard({ value, label, icon }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'center' }}>{icon}</div>
      <div style={{ fontSize: '20px', fontWeight: 900, color: '#0B2C5F', marginBottom: '4px' }}>{value}</div>
      <div style={{ fontSize: '12px', fontWeight: 600, color: '#6B7280' }}>{label}</div>
    </div>
  );
}

function TimelineItem({ year, title, text, last }) {
  return (
    <div style={{ position: 'relative', paddingBottom: last ? '0' : '28px' }}>
      <div style={{
        position: 'absolute',
        left: '-27px',
        top: '4px',
        width: '14px',
        height: '14px',
        borderRadius: '50%',
        background: '#0B2C5F',
        border: '3px solid #fff',
        boxShadow: '0 0 0 2px #0B2C5F'
      }} />
      <div style={{ paddingLeft: '8px' }}>
        <span style={{ fontSize: '12px', fontWeight: 700, color: '#D4AF37', textTransform: 'uppercase', letterSpacing: '1px' }}>{year}</span>
        <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#0B2C5F', marginTop: '4px', marginBottom: '4px' }}>{title}</h3>
        <p style={{ fontSize: '14px', color: '#6B7280', lineHeight: 1.5 }}>{text}</p>
      </div>
    </div>
  );
}
